var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-button",on:{"click":_vm.goHome}},[_c('van-icon',{attrs:{"name":"wap-home","size":"15"}}),_c('div',{staticClass:"home-button-text"},[_vm._v("首页")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }